import { Box, Button, IconButton, LinearProgress, Link, Menu, MenuItem, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { LoggedInUserInfo } from "../../components/Elements/loggedInUserInfo";
import { RightNav } from "../../components/Nav/RightNav";
import { config } from "../../Constants";
import useAuth from "../../context/AuthProvider";

import { DataGrid, getGridStringOperators, GridColDef, GridColumnMenuContainer, GridColumnMenuProps, GridColumnsMenuItem, GridFilterMenuItem, GridFilterModel, GridFilterOperator, GridRowId, GridSelectionModel, GridSortModel, GridToolbar, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, HideGridColMenuItem, SortGridMenuItems } from "@mui/x-data-grid";
import React from "react";
import { PolicyDocumentsPopup } from "./PolicyDocumentsPopup";
import { AddDocument } from "../../CustomerPanel/AddDocuments";
import moment from "moment";
import { RiExpandUpDownLine } from "react-icons/ri";
import { FMFilters, getCompletedFilings__Resp, NewCompletedFilingsModel } from "../../models/NewCompletedFilingsModel";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Stack, width } from "@mui/system";
import { DataGridPro, DataGridProProps, useGridApiRef } from "@mui/x-data-grid-pro";
import { MenuDropdown } from "../../components/Elements/MenuDropdown";
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import RestorePageOutlinedIcon from '@mui/icons-material/RestorePageOutlined';
import formatPrice from "../../helper/currencyFormatter";
import { formatUtcToLocal } from "../../helper/utils";
import { getRowsPerPageOptions } from "../../components/AddEdit/CustomFunctions";
import { FMTabs } from "../Tabs";
import { apiClient } from "../../helper/api";
import { AppFlags } from "../../helper/config";
import EditIcon from '@mui/icons-material/Edit';
import { KeyboardArrowUp, KeyboardArrowDown, FileDownload } from "@mui/icons-material";
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Link as RouterLink } from "react-router-dom";
import useAppDialog from "../../hooks/useAppDialog";
import { DialogResponse, DialogResult } from "../../components/Dialog/dialogTypes";


interface CompletedFilingsModel {
  customerPolicyId: number,
  carrier: string,
  effectiveDate: string,
  policyNumber: string,
  namedInsured: string,
  state: string,
  doucmentsUploaded: number,
  error: string,
  customerName: string,
  errorsCount: 0,
  slNo?: number,
  policyId: number,
  transactionType?: string,
  dateCreated?: string,
  status?: string

}


interface Iprops {
  NewCompletedFilingsCL: getCompletedFilings__Resp;
  fetchFilingQueueData: (
    pageNumber: number,
    pageSize: number
  ) => void;
  closePolicy: (
    custPolicyId: number,
    action: string,
    value: number,
    message: string,
    isClosed: boolean,
    isRestoreToRec: boolean
  ) => void;
  getCustomerPolicyListbyTaxType: (
    action: string,
    customerPolicyIds: number[],
    option: string
  ) => void;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  currentPage: number
  setPageSize: React.Dispatch<React.SetStateAction<number>>
  pageSize: number
  filterModel: any;
  setFilterModel: React.Dispatch<React.SetStateAction<any>>;
  sortModel: any;
  setSortModel: React.Dispatch<React.SetStateAction<any>>;
  setSelectedRows: React.Dispatch<React.SetStateAction<NewCompletedFilingsModel[] | null>>;
  selectedRows: NewCompletedFilingsModel[] | null;
}

export const CompletedFilings: React.FC<Iprops> = ({
  NewCompletedFilingsCL,
  fetchFilingQueueData,
  closePolicy,
  getCustomerPolicyListbyTaxType,
  setCurrentPage,
  currentPage,
  setPageSize,
  pageSize,
  filterModel,
  setFilterModel,
  sortModel,
  setSortModel,
  setSelectedRows,
  selectedRows,
}) => {
  const { user } = useAuth();
  const token = user?.token;
  const { openDialog_Message } = useAppDialog();
  const userRolesList = user?.userRoles.split(",").map((r) => r.trim()) ?? [];
  const isSuperAdmin = userRolesList.includes("Super Admin");
  const isMiscFiler = userRolesList.includes("MISC Filer");
  const isMiscStateReporter = userRolesList.includes("MISC State Reporter");
  const showCompletedActionColumn = isSuperAdmin || isMiscFiler || isMiscStateReporter;
  const theme = useTheme();
  const isTabletOrDown = useMediaQuery(theme.breakpoints.down('md'));
  const completedFilingsGridApiRef = useGridApiRef();
  const [loading, setloading] = useState(false);
  const [Formdata, setFormData] = React.useState([]);
  const [Open, setOpen] = React.useState(false);
  const [OpenError, setOpenError] = React.useState(false);
  const [OpenDocResubmission, setDocResubmission] = React.useState(false);
  const [custPolId, setcustPolId] = React.useState("0");
  const [selectedState, setselectedState] = useState("");

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClickOpenActionOptions = (customerPolicyId: number) => {
    const buttonEl = document.getElementById(`action-options-button-${customerPolicyId}`) as HTMLElement | null;
    setAnchorEl((prev) => (prev?.id === `action-options-button-${customerPolicyId}` ? null : buttonEl));
  };
  const handleCloseActionOptions = () => {
    setAnchorEl(null);
  };

  const handleOpenMessageCenter = (custPolicyId: number) => {
    void openDialog_Message({
      custPolId: String(custPolicyId),
      viewOnly: !isSuperAdmin,
    }).then((res: DialogResponse) => {
      if (res.dialogResult === DialogResult.OK) {
        void fetchFilingQueueData(currentPage, pageSize);
      }
    });
  };

  const handleDocumentReubmission = (id: number) => {
    setcustPolId(String(id));
    setDocResubmission(true);
  };

  const handleEdit = (custPolId: number) => {
    apiClient(`/PolicyDashBoard/getCustomerPolicyDocumentDetails?CustPolicyId=${custPolId}`,
      {
        method: "GET",
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        })
      })
      .then((responseJson) => {
        if (!responseJson) return
        console.log(responseJson);
        setFormData(responseJson.data);
      })

    setOpen(true);
  };
  const handleClose = () => {
    setFormData([]);
    setOpen(false);
    setOpenError(false);
    setDocResubmission(false);
  };

  const handleCloseDocumentUpload = () => {
    setDocResubmission(false);
    void fetchFilingQueueData(currentPage, pageSize);
  };

  const initialdata: NewCompletedFilingsModel = {
    customerPolicyId: 0,
    homeState: "",
    policyId: 0,
    dueDate: ""
  }

  const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = React.useState<GridRowId[]>([]);
  const handleDetailPanelExpandedRowIdsChange = React.useCallback((newIds: GridRowId[]) => {
    setDetailPanelExpandedRowIds(newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds,);
  },
    [],
  );

  const handlehandleApprove = (custPolId: number) => {
    setloading(true);
    apiClient(`/PolicyDashBoard/Approve?custPolId=${custPolId}`,
        {
            method: "GET",
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            })
        })
        .then((responseJson) => {
            if (!responseJson) return
            setloading(false);
            fetchFilingQueueData(currentPage, pageSize);
            setloading(false);
        })
        .finally(() => {
            setloading(false);
        });
};

  const filterOperators = getGridStringOperators().filter(({ value }) => ['contains'].includes(value));
  const equalOperators: GridFilterOperator<any, string | number | null, any>[] =  getGridStringOperators().filter(({ value }) => ['equals'].includes(value));

  const getDetailPanelContent = React.useCallback<NonNullable<DataGridProProps['getDetailPanelContent']>>(({ row }) => <DetailPanelContent row={row} />, []);
  const getDetailPanelHeight = React.useCallback(() => 200, []);
  function DetailPanelContent({ row }: { row: NewCompletedFilingsModel }) {
    const [TaxNamAndData, setTaxNamAndData] = useState<NewCompletedFilingsModel[]>([initialdata]);
    const [isLoadingChild, setIsLoadingChild] = useState(true);
    const TaxNameAndDate = () => {

      setTaxNamAndData([])
      setIsLoadingChild(true);
      apiClient(`/PolicyDashBoard/getaxTypeandDateByCustpolicyid?customerPolicyId=${row.customerPolicyId}`,
        {
          method: "GET",
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          })
        })
        .then((responseJson) => {
          if (responseJson?.data != null) {
            setIsLoadingChild(false);
            setTaxNamAndData(responseJson.data)
            console.log("taxData", responseJson)

          }

        });
    }
    useEffect(() => {
      TaxNameAndDate();
    }, [row])

    const rows = [
      {
        TaxNamAndData
      }
    ];
    return (

      <Stack direction="column" spacing={1} sx={{ height: 1, paddingLeft: isTabletOrDown ? '50px' : '170px' }} className="hide-border-12" >

        <DataGridPro
          columns={[
            {
              field: 'taxType',
              type: 'string',
              headerName: 'Tax Type',
              flex: 1,
              headerAlign: "left",
              hideSortIcons: true,
              maxWidth: 200,
              renderHeader: (params) => (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  <RiExpandUpDownLine />
                </div>
              ),
              align: "left",
            },

            {
              field: 'taxAmt', hideSortIcons: true,
              renderHeader: (params) => (
                <div>
                  <span className="table-card-title" >{params.colDef.headerName}</span>
                  <RiExpandUpDownLine />
                </div>
              ), type: 'string', headerName: 'Tax Amount', flex: 0.5, align: 'right', headerAlign: 'right', maxWidth: 150,
              renderCell: (params) => {
                const value = params.value || '0'; // Default to '0' if value is null or undefined
                return (
                  <Box display="flex" alignItems="left" justifyContent="left">

                    {formatPrice(value)}

                  </Box>
                )
              }

            },


          ]}
          rows={TaxNamAndData}
          getRowId={(r) => r?.rowNum ?? 0}
          sx={{
            flex: 1,
            '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f8fafc !important',
                borderBottom: '2px solid #e2e8f0 !important',
            },
          }}
          hideFooter
          loading={isLoadingChild}
        />
      </Stack>
    );
  }



  const columns: GridColDef[] = [
    {
      field: 'dueDate', hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'dueDate'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      }, type: 'string', headerName: 'Filing Due Date', flex: 0.5, minWidth: 170, align: 'left', headerAlign: 'left',
      valueGetter: (params) =>
      (
        new Date(params.row.dueDate)
      ),
      renderCell: (params) =>
      (
        <div>
          {(params.row.dueDate != null && params.row.dueDate != '') ? formatUtcToLocal(params.row.dueDate, "MM/DD/YYYY") : ""}
        </div>
      )
    },
    {
      field: 'Action', flex: 0.8, minWidth: 115, filterable: false, hideSortIcons: true,
      sortable: false,
      disableColumnMenu: true,
      headerName: "Action", headerAlign: 'center', align: 'center', disableExport: true,
      hide: !showCompletedActionColumn,
      renderCell: (params) =>
      (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '4px' }}>
          <Button
            size="small"
            style={{ minWidth: '0px' }}
            id={`action-options-button-${params.row.customerPolicyId}`}
            aria-controls={anchorEl?.id === `action-options-button-${params.row.customerPolicyId}` ? `action-options-menu-${params.row.customerPolicyId}` : undefined}
            aria-haspopup="true"
            aria-expanded={anchorEl?.id === `action-options-button-${params.row.customerPolicyId}` ? 'true' : undefined}
            onClick={(e) => {
              e.stopPropagation();
              handleClickOpenActionOptions(params.row.customerPolicyId);
            }}
          >
            <MoreVertOutlinedIcon fontSize="small" />
          </Button>
          <Menu
            id={`action-options-menu-${params.row.customerPolicyId}`}
            aria-labelledby={`action-options-button-${params.row.customerPolicyId}`}
            anchorEl={anchorEl}
            open={Boolean(anchorEl && anchorEl.id === `action-options-button-${params.row.customerPolicyId}`)}
            onClose={handleCloseActionOptions}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            MenuListProps={{
              'aria-labelledby': `action-options-button-${params.row.customerPolicyId}`,
            }}
            sx={{
              '& .MuiMenuItem-root': {
                fontSize: '14px',
                padding: '8px 16px',
              },
            }}
          >
            {params.row.policyId != null && params.row.policyId > 0 ? (
              <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}>
                <Link
                  href={`/Transaction/${params.row.policyId}/${params.row.customerPolicyId}`}
                  color="inherit"
                  sx={{ textDecoration: 'none' }}
                  target=""
                >
                  <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> View transaction details
                </Link>
              </MenuItem>
            ) : null}
            <MenuItem
              component={RouterLink}
              to={
                isSuperAdmin
                  ? `/Admin/AddEditCustomerPolicyDetails/${params.row.customerPolicyId}`
                  : `/Admin/AddEditCustomerPolicyDetails/${params.row.customerPolicyId}?fromQueue=completed`
              }
              onClick={(e) => {
                handleCloseActionOptions();
                e.stopPropagation();
              }}
              sx={{ color: 'inherit', textDecoration: 'none' }}
            >
              <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Update Policy
            </MenuItem>
            {isSuperAdmin ? (
              <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); closePolicy(params.row.customerPolicyId, 'getClosedFilingsFilterData', 5, 'Do you want to Restore to Filing Queue ?', false, true); }}>
                <SettingsBackupRestoreIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Restore
              </MenuItem>
            ) : null}
          </Menu>
          <Tooltip title="Message center">
            <IconButton
              size="small"
              aria-label="Message center"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenMessageCenter(params.row.customerPolicyId);
              }}
            >
              <MailOutlineIcon fontSize="small" color="action" />
            </IconButton>
          </Tooltip>
        </Box>
      )
    },
    {
      field: 'agency', hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'agency'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      }, type: 'string', headerName: 'Client', flex: 0.35, minWidth: 100, align: 'left', headerAlign: 'left' , filterOperators
    },
    {
      field: 'invoiceNumber', hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'invoiceNumber'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      }, type: 'string', headerName: 'Invoice Number', flex: 0.68, minWidth: 175, align: 'left', headerAlign: 'left' , filterOperators
    },

    {
      field: 'insuredName',
      type: 'string',
      headerName: 'Insured Name',
      flex: .6,
      minWidth: 160,
      headerAlign: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'insuredName'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      },
      align: "left",
      filterOperators,
    },
    {
      field: 'policyNumber',
      type: 'string',
      headerName: 'Policy Number',
      flex: 0.75,
      minWidth: 165,
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'policyNumber'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      },
      headerAlign: "left",
      align: "left",
      filterOperators,
    },

    {
      field: "homeState",
      type: "string",
      headerName: "Home State",
      flex: 0.60,
      minWidth: 145,
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'homeState'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      },
      align: "left",
      headerAlign: "left",
      filterOperators,
    },

    {
      field: "transactionTypeName",
      type: "string",
      headerName: "Transaction Type",
      flex: 0.7, hideSortIcons: true,
      minWidth: 185,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'transactionTypeName'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      },
      align: "left",
      headerAlign: "left",
      filterOperators,
    },
    
    {
      field: 'invoiceDate', hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'invoiceDate'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      }, type: 'string', headerName: 'Invoice Date', flex: 0.7, minWidth: 150, align: 'left', headerAlign: 'left', filterOperators: equalOperators, 
      renderCell: (params) =>
      (
          <div>
              {(params.row.invoiceDate != null && params.row.invoiceDate != '') ? formatUtcToLocal(params.row.invoiceDate, "MM/DD/YYYY") : ""}
          </div>
      )
  },
    {
      field: 'effectiveDate', hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'effectiveDate'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      }, type: 'string', headerName: 'Policy Effective Date', flex: 0.7, minWidth: 210, align: 'left', headerAlign: 'left', filterOperators: equalOperators,
      renderCell: (params) =>
      (
        <div>
          {(params.row.effectiveDate != null && params.row.effectiveDate != '') ? formatUtcToLocal(params.row.effectiveDate, "MM/DD/YYYY") : ""}
        </div>
      )
    },

    {
      field: 'policyExpDate', hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'policyExpDate'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      }, type: 'string', headerName: 'Policy Expiration Date', minWidth: 220, flex: 0.9, align: 'left', filterOperators: equalOperators,
      headerAlign: 'left', renderCell: (params) =>
      (
        <div>
          {(params.row.policyExpDate != null && params.row.policyExpDate != '') ? formatUtcToLocal(params.row.policyExpDate, "MM/DD/YYYY") : ""}
        </div>
      ),

    },
    {
      field: 'grossPremium',
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'grossPremium'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      },
      type: 'string',
      headerName: 'Gross Premium',
      flex: 0.5,
      minWidth: 175,
      align: 'right',
      headerAlign: 'right',
      filterOperators,
      renderCell: (params) => {
          let grossPremium = params.value || '0'; // Default to '0' if value is null or undefined
  
          // Trim any spaces and remove the dollar sign and commas
          let cleanedValue = grossPremium.replace(/[,\$]/g, "").trim();
  
          // If the value is in parentheses, it's negative, so handle that
          if (cleanedValue.startsWith("(") && cleanedValue.endsWith(")")) {
              cleanedValue = "-" + cleanedValue.slice(1, -1); // Remove parentheses and add a negative sign
          }
  
          // Convert to number
          const numericValue = parseFloat(cleanedValue);
  
          // If numericValue is a valid number, format it; otherwise, return the original string
          return (
              <Box display="flex" alignItems="left" justifyContent="center">
                  {isNaN(numericValue) ? grossPremium : `${formatPrice(numericValue.toString())}`}
              </Box>
          );
      }
    },
  
    {
      field: 'status', hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'status'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      },
      renderCell: (params) => {
        return (
          <div>
            <span className={`badge ${params.row.status === 'Filed' ? 'bg-success' : params.row.status === 'Removed' ? 'bg-danger' : 'bg-warning'}`}>
              {params.row.status}
            </span>
          </div>
        )
      },
      type: 'string', headerName: 'Status', flex: 0.4, minWidth: 100, align: 'left', headerAlign: 'left' , filterOperators,
    },
  ]

  const handleExport = (option: string) => {
    var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId) ?? [];
    getCustomerPolicyListbyTaxType("getCustomerPolicyListbyTaxType", customerPolicyIds, option);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer  >
        <GridToolbarFilterButton className="me-3 sky-blue" />
        <GridToolbarColumnsButton className="me-3 sky-blue" />
        <GridToolbarExport className="me-3 sky-blue" />
      </GridToolbarContainer>

    );
  }
  const exportOptions = [
    'Short', 'Detailed'
  ]
  const exportOptionsAdmin = [
    'Short', 'Detailed', 'All'
  ]
  function EditToolbar() {
    const [toolbarMenuAnchor, setToolbarMenuAnchor] = useState<null | HTMLElement>(null);
    const openToolbarMenu = Boolean(toolbarMenuAnchor);

    const handleToolbarMenuClose = () => setToolbarMenuAnchor(null);
    const handleToolbarAction = (action: 'filter' | 'columns' | 'exportCsv' | 'exportPrint') => {
      handleToolbarMenuClose();
      const api = completedFilingsGridApiRef.current;
      if (!api) return;
      if (action === 'filter') api.showFilterPanel();
      else if (action === 'columns') (api as any).showPreferences('columns');
      else if (action === 'exportCsv') api.exportDataAsCsv();
      else if (action === 'exportPrint') api.exportDataAsPrint();
    };

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, py: 1.5, px: 1 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#334155', mr: 'auto', pl: 1 }}>Completed Filings</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isTabletOrDown ? (
            <>
              <IconButton
                aria-label="Table options"
                aria-controls={openToolbarMenu ? 'table-options-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openToolbarMenu ? 'true' : undefined}
                onClick={(e) => setToolbarMenuAnchor(e.currentTarget)}
                sx={{ color: '#2099d2' }}
              >
                <MoreVertOutlinedIcon />
              </IconButton>
              <Menu
                id="table-options-menu"
                anchorEl={toolbarMenuAnchor}
                open={openToolbarMenu}
                onClose={handleToolbarMenuClose}
                MenuListProps={{ 'aria-labelledby': 'table-options-button' }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <MenuItem onClick={() => handleToolbarAction('filter')}>Filter</MenuItem>
                <MenuItem onClick={() => handleToolbarAction('columns')}>Columns</MenuItem>
                <MenuItem onClick={() => handleToolbarAction('exportCsv')}>Download as CSV</MenuItem>
                <MenuItem onClick={() => handleToolbarAction('exportPrint')}>Print</MenuItem>
              </Menu>
            </>
          ) : (
            <CustomToolbar />
          )}
        </Box>
        <Box sx={{ zIndex: 9 }}>
          <MenuDropdown
            menuTitle="Export"
            items={user?.userRoles.split(",").includes("Super Admin") ? exportOptionsAdmin : exportOptions}
            onItemClick={handleExport}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              backgroundColor: '#2099d2',
              '&:hover': { backgroundColor: '#176990' },
              px: 2,
            }}
            startIcon={<FileDownload />}
          />
        </Box>
      </Box>
    );
  }

  const onRowsSelectionHandler = (ids: GridSelectionModel | undefined) => {

    const selectedIDs = new Set(ids);
    const uniqueRowsIds = new Set();
    const selectedRowData = NewCompletedFilingsCL.getCompletedFilings_Respdata.filter((row) => {
      if (selectedIDs.has(row?.customerPolicyId ?? "") && !uniqueRowsIds.has(row?.customerPolicyId ?? "")) {
        uniqueRowsIds.add(row?.customerPolicyId ?? "");
        return true;
      }
      return false;
    });
    if (ids?.[0] != null || undefined) {
      setselectedState(
        NewCompletedFilingsCL.getCompletedFilings_Respdata.find((x) => x.customerPolicyId === Number(ids?.[0]))?.homeState ?? ""
      );
    }
    setSelectedRows(selectedRowData);
  };
  const isRowSelectable = (params: { row: { homeState: string; transactionTypeName: string }; }) => {
    if (selectedState === 'NY') {
      return params.row.homeState === 'NY';
    } else if (selectedState !== '') {
      return params.row.homeState !== 'NY';
    }
    return true;
  };

  function CustomColumnMenu(props: GridColumnMenuProps) {
    const { hideMenu, currentColumn, color, ...other } = props;

    return (
      <GridColumnMenuContainer
        hideMenu={hideMenu}
        currentColumn={currentColumn}
        {...other}
      >
        <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
        <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
        <HideGridColMenuItem onClick={hideMenu} column={currentColumn} />
        <GridColumnsMenuItem onClick={hideMenu} column={currentColumn} />
      </GridColumnMenuContainer>
    );
  }

  return (
    <Box sx={{ height: { xs: "100vh", sm: "calc(100vh - 300px)" }, display: "flex", flexDirection: "column", width: "100%", borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)', border: '1px solid #e2e8f0', backgroundColor: '#ffffff' }}>
      {loading && <LinearProgress sx={{ backgroundColor: "#2099d2" }} />}
      <div style={{ flex: '1 1 0%', overflow: 'auto' }}>
        <DataGridPro
          apiRef={completedFilingsGridApiRef}
          rowHeight={60}
          getRowId={(r) => r.customerPolicyId}
          rowCount={NewCompletedFilingsCL?.totalCount}
          rows={NewCompletedFilingsCL.getCompletedFilings_Respdata}
          columns={columns}
          loading={loading}
          pageSize={pageSize}
          getDetailPanelHeight={getDetailPanelHeight}
          getDetailPanelContent={getDetailPanelContent}
          detailPanelExpandedRowIds={detailPanelExpandedRowIds}
          onDetailPanelExpandedRowIdsChange={handleDetailPanelExpandedRowIdsChange}
          pagination
          paginationMode="server"
          sortingMode="server"
          onPageChange={(newPage) => setCurrentPage(newPage + 1)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
          sortModel={sortModel}
          sortingOrder={['desc', 'asc']}
          rowsPerPageOptions={getRowsPerPageOptions(NewCompletedFilingsCL?.totalCount, pageSize)}
          checkboxSelection={
            user?.userRoles.split(",").includes("Super Admin") ||
              user?.userRoles.split(",").includes("MISC Filer") ||
              user?.userRoles.split(",").includes("MISC State Reporter") ? true : false
          }
          onSelectionModelChange={(newRowSelectionModel) => {
            onRowsSelectionHandler(newRowSelectionModel);
          }}
          selectionModel={selectedRows?.map((row) => row.customerPolicyId) as GridRowId[]}
          disableSelectionOnClick
          initialState={isTabletOrDown ? undefined : { pinnedColumns: { left: ['dueDate'] } }}
          filterMode="server"
          onFilterModelChange={(newFilterModel: any) => setFilterModel(newFilterModel)}
          filterModel={filterModel}
          getRowClassName={(params) => {
            const isUploaded = String(params.row.isDocsUploaded) === 'true';
            const isClient =  Number(params.row.isClient ) === 1; 
            return isUploaded && isClient ? `custom-row-bg-${isUploaded ? 'green' : ''}` : 'without-documents';
          }}
          components={{
            Toolbar: EditToolbar,
            ColumnMenu: CustomColumnMenu
          }}
          sx={{
            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            border: 'none',
            fontSize: '14px',
            color: '#475569',
            backgroundColor: '#ffffff',
            "& .MuiDataGrid-detailPanel": {
              zIndex: 'auto',
            },
            // Match MUI X defaults; stay well below theme.zIndex.modal (1300) so dialogs/popovers cover pinned cells.
            '& .MuiDataGrid-pinnedColumns--left': {
              zIndex: 1,
            },
            '& .MuiDataGrid-pinnedColumnHeaders': {
              zIndex: 2,
            },
            "& .MuiDataGridPro-columnHeaderTitle": {
              whiteSpace: 'normal',
              lineHeight: 1.35,
              fontWeight: 600,
              fontSize: '12px',
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              color: '#64748b',
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: '#f8fafc',
              borderBottom: '2px solid #e2e8f0',
              borderTop: '2px solid #e2e8f0',
              minHeight: '52px !important',
              maxHeight: '52px !important',
            },
            "& .MuiDataGrid-columnHeader": {
              "&:focus, &:focus-within": { outline: 'none' },
            },
            "& .MuiDataGrid-row": {
              transition: 'background-color 0.15s ease',
              "&:nth-of-type(even)": {
                backgroundColor: '#fafbfc',
              },
              "&:hover": {
                backgroundColor: '#f1f5f9 !important',
              },
              "&.Mui-selected": {
                backgroundColor: '#ebf5fa !important',
                "&:hover": {
                  backgroundColor: '#dbeef7 !important',
                },
              },
            },
            "& .MuiDataGrid-cell": {
              borderBottom: '1px solid #f1f5f9',
              fontSize: '14px',
              color: '#334155',
              overflow: 'visible',
              whiteSpace: 'normal',
              lineHeight: 'normal',
              wordWrap: 'break-word',
              textOverflow: 'clip',
              "&:focus": { outline: 'none' },
            },
            "& .MuiDataGrid-virtualScroller": {
              border: 'none',
            },
            "& .MuiDataGrid-main": {
              border: 'none',
            },
            "& .custom-row-bg-green .MuiDataGrid-cell": { backgroundColor: '#a2dda2' },
            "& .MuiDataGrid-checkboxInput": { marginLeft: '-12px' },
            "& .documents-uploded": { paddingRight: '10px' },
            "& .MuiDataGrid-footerContainer": {
              borderTop: '1px solid #e2e8f0',
              backgroundColor: '#f8fafc',
              minHeight: 56,
            },
            "& .MuiTablePagination-root": {
              color: '#64748b',
              fontSize: '13px',
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
              marginBottom: 0,
            },
            "& .MuiTablePagination-select": {
              fontSize: '13px',
              borderRadius: '6px',
              border: '1px solid #e2e8f0',
            },
            "& .MuiIconButton-root": {
              color: '#64748b',
              "&:hover": {
                backgroundColor: '#f1f5f9',
                color: '#475569',
              },
            },
            "& .MuiCheckbox-root": {
              color: '#94a3b8',
              "&.Mui-checked": {
                color: '#2099d2',
              },
            },
          }}
        />
        </div>
        <PolicyDocumentsPopup handleClose={handleClose} Open={Open} documentList={Formdata} />
        <AddDocument
          open={OpenDocResubmission}
          handleClose={handleCloseDocumentUpload}
          customerPolicyId={custPolId}
          currentUser={user ?? undefined}
          viewOnly={false}
        />
    </Box>
  )
}